<!--  表單標題 -->
<template>
<div class="sub-content"><slot></slot></div>
</template>
<script>
export default {
  name: 'sub-content-qa',
  data () {
    return {
    }
  }

}
</script>
<style lang="stylus" scoped>

.sub-content
  color $info-color-content
  padding-left:27px
  display: flex;
  align-items: center;
</style>
